import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'vue-good-table/dist/vue-good-table.css'
import '../assets/scss/style.scss'

Vue.use(BootstrapVue)
